import React, { useState, useEffect } from "react";
import { ModalSecurityCodeContainer } from "./ModalSecurityCodeStyled";
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from "react-router-dom";

import close from './../../utils/images/close_circle.svg';
import AuthCode from 'react-auth-code-input';

import { postInfluencer, postCompany, postEmailToObtainVerificationCode, getStatusVerificationCode } from './../../api/signUpApi';

import Alert from "../Alert/Alert";
import Spinner from './../../components/Spinner/Spinner';


export default function ModalSecurityCode({ setShowSecurityCode, body, activeUser, setShowAlertSuccessful, setShowAlertUserExists, page, setIsEmailVerified }) {

    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const intl = useIntl();

    const [showAlertNewCode, setShowAlertNewCode] = useState(false);
    const [showAlertError, setShowAlertError] = useState(false);

    const handleOnChange = (res) => {
        setCode(res);
    };

    useEffect(() => {
        if (code.length > 5) {
            setIsLoading(true);

            getStatusVerificationCode({ code: code, email: body.mail }).then((response) => {

                if (page === 'MyAccount') {
                    setIsLoading(false);
                    if (response) {
                        setIsEmailVerified(response);
                        setShowSecurityCode(false);
                    } else {
                        setShowAlertError(true);
                    }

                } else if (page === 'login') {
                    setIsLoading(false);
                    if (response) {
                        setIsEmailVerified(response);
                        setShowSecurityCode(false);
                    } else {
                        setShowAlertError(true);
                    }
                } else {
                    if (response) {
                        if (activeUser === 'influencer') {
                            postInfluencer({ body }).then((response) => {
                                setIsLoading(false);
                                setShowSecurityCode(false);
                                if (response.status === 201) {
                                    setShowAlertSuccessful(true);
                                    navigate('/signup');
                                } else if (response.status === 409) {
                                    setShowAlertUserExists(true);
                                    navigate('/signup');
                                }
                            })
                        } else {
                            postCompany({ body }).then((response) => {
                                setIsLoading(false);
                                setShowSecurityCode(false);
                                if (response.status === 201) {
                                    setShowAlertSuccessful(true);
                                    navigate('/signup');
                                } else if (response.status === 409) {
                                    setShowAlertUserExists(true);
                                    navigate('/signup');
                                }
                            })
                        }
                    } else {
                        setIsLoading(false);
                        setShowAlertError(true);
                    }

                }

            }
            )
        }
    }, [code])

    const sendCodeToEmail = () => {
        setIsLoading(true);
        postEmailToObtainVerificationCode({ email: body.mail }).then((response) => {
            setIsLoading(false);
            setShowAlertNewCode(true);
        })
    }

    useEffect(() => {
        postEmailToObtainVerificationCode({ email: body.mail }).then((response) => {
            console.log(response)
        })
    }, [])

    return (
        <ModalSecurityCodeContainer>

            <img src={close} alt="close" className="closeOutside" onClick={() => { setShowSecurityCode(false) }} />

            <form action="" className="securityBody">
                <div className="header">
                    <h2 className="title"><FormattedMessage id="securityCode_title" defaultMessage="Ingresa tu código de seguridad" /></h2>

                    <img src={close} alt="close" className="close" onClick={() => { setShowSecurityCode(false) }} />
                </div>
                <p className="firstText">
                    <FormattedMessage id="securityCode_text_1" defaultMessage="Hemos enviado un código a " />
                    {body.mail}
                    <FormattedMessage id="securityCode_text_2" defaultMessage=", que deberías recibir en los próximos 3 minutos. Por favor, introduzca el código de abajo:" />
                </p>


                <div className="code">
                    <AuthCode onChange={handleOnChange} inputClassName='codeNumber' />
                </div>



                <p className="secondText">
                    <FormattedMessage id="securityCode_text_3" defaultMessage="¿No has recibido el código?" />
                    <span className="resend" onClick={sendCodeToEmail}>
                        <FormattedMessage id="securityCode_text_4" defaultMessage="Reenviar mensaje" />
                    </span>
                </p>

            </form>

            {(showAlertNewCode) && (<Alert
                title={<FormattedMessage id="alert_forward_title" defaultMessage="¡Exitoso!" />}
                text={<FormattedMessage id="alert_forward_text" defaultMessage="Se ha enviado un nuevo código a su correo" />}
                setShowAlert={setShowAlertNewCode}
            />)}

            {(showAlertError) && (<Alert
                title={<FormattedMessage id="alert_error_code_title" defaultMessage="Código incorrecto" />}
                text={<FormattedMessage id="alert_error_code_text" defaultMessage="Por favor verifique e intente de nuevo" />}
                setShowAlert={setShowAlertError}
            />)}

            {(isLoading) && (<Spinner />)}

        </ModalSecurityCodeContainer>
    )
}